import React from 'react';
import { cn } from './cn';

function Card({ className, ...props }) {
  return <div className={cn('ui-card', className)} {...props} />;
}

function CardHeader({ className, ...props }) {
  return <div className={cn('ui-card-header', className)} {...props} />;
}

function CardTitle({ className, ...props }) {
  return <div className={cn('ui-card-title', className)} {...props} />;
}

function CardDescription({ className, ...props }) {
  return <div className={cn('ui-card-description', className)} {...props} />;
}

function CardAction({ className, ...props }) {
  return <div className={cn('ui-card-action', className)} {...props} />;
}

function CardContent({ className, ...props }) {
  return <div className={cn('ui-card-content', className)} {...props} />;
}

function CardFooter({ className, ...props }) {
  return <div className={cn('ui-card-footer', className)} {...props} />;
}

export { Card, CardHeader, CardTitle, CardDescription, CardAction, CardContent, CardFooter };
